export type ZendeskEnvironment = 'production' | 'sandbox'

export type ZendeskFieldIds = {
  document: string
  sellerId: string
  sellerName: string
  city: string
}

const buildTimeZendeskEnv = {
  ENV: process.env.ENV,
  ZENDESK_SNIPPET_URL: process.env.ZENDESK_SNIPPET_URL,
  ZENDESK_SNIPPET_URL_SANDBOX: process.env.ZENDESK_SNIPPET_URL_SANDBOX,
  ZENDESK_SNIPPET_URL_PRODUCTION: process.env.ZENDESK_SNIPPET_URL_PRODUCTION,
  ZENDESK_CONTEXT_FIELD_DOCUMENT_SANDBOX:
    process.env.ZENDESK_CONTEXT_FIELD_DOCUMENT_SANDBOX,
  ZENDESK_CONTEXT_FIELD_POC_ID_SANDBOX:
    process.env.ZENDESK_CONTEXT_FIELD_POC_ID_SANDBOX,
  ZENDESK_CONTEXT_FIELD_POC_NAME_SANDBOX:
    process.env.ZENDESK_CONTEXT_FIELD_POC_NAME_SANDBOX,
  ZENDESK_CONTEXT_FIELD_CITY_SANDBOX:
    process.env.ZENDESK_CONTEXT_FIELD_CITY_SANDBOX,
  ZENDESK_CONTEXT_FIELD_DOCUMENT_PRODUCTION:
    process.env.ZENDESK_CONTEXT_FIELD_DOCUMENT_PRODUCTION,
  ZENDESK_CONTEXT_FIELD_POC_ID_PRODUCTION:
    process.env.ZENDESK_CONTEXT_FIELD_POC_ID_PRODUCTION,
  ZENDESK_CONTEXT_FIELD_POC_NAME_PRODUCTION:
    process.env.ZENDESK_CONTEXT_FIELD_POC_NAME_PRODUCTION,
  ZENDESK_CONTEXT_FIELD_CITY_PRODUCTION:
    process.env.ZENDESK_CONTEXT_FIELD_CITY_PRODUCTION,
}

const getZendeskEnvValue = (key: keyof typeof buildTimeZendeskEnv) =>
  globalThis.process?.env?.[key] ?? buildTimeZendeskEnv[key] ?? ''

const getEnvironment = (): ZendeskEnvironment =>
  getZendeskEnvValue('ENV') === 'production' ? 'production' : 'sandbox'

export const getZendeskEnvironment = () => getEnvironment()

const getSandboxZendeskSnippetUrl = () =>
  getZendeskEnvValue('ZENDESK_SNIPPET_URL_SANDBOX') ||
  getZendeskEnvValue('ZENDESK_SNIPPET_URL')

const getProductionZendeskSnippetUrl = () =>
  getZendeskEnvValue('ZENDESK_SNIPPET_URL_PRODUCTION') ||
  getZendeskEnvValue('ZENDESK_SNIPPET_URL')

export const getZendeskSnippetUrl = () =>
  getEnvironment() === 'production'
    ? getProductionZendeskSnippetUrl()
    : getSandboxZendeskSnippetUrl()

const getSandboxZendeskContextFieldIds = (): ZendeskFieldIds => ({
  document: getZendeskEnvValue('ZENDESK_CONTEXT_FIELD_DOCUMENT_SANDBOX'),
  sellerId: getZendeskEnvValue('ZENDESK_CONTEXT_FIELD_POC_ID_SANDBOX'),
  sellerName: getZendeskEnvValue('ZENDESK_CONTEXT_FIELD_POC_NAME_SANDBOX'),
  city: getZendeskEnvValue('ZENDESK_CONTEXT_FIELD_CITY_SANDBOX'),
})

const getProductionZendeskContextFieldIds = (): ZendeskFieldIds => ({
  document: getZendeskEnvValue('ZENDESK_CONTEXT_FIELD_DOCUMENT_PRODUCTION'),
  sellerId: getZendeskEnvValue('ZENDESK_CONTEXT_FIELD_POC_ID_PRODUCTION'),
  sellerName: getZendeskEnvValue('ZENDESK_CONTEXT_FIELD_POC_NAME_PRODUCTION'),
  city: getZendeskEnvValue('ZENDESK_CONTEXT_FIELD_CITY_PRODUCTION'),
})

export const getZendeskContextFieldIds = (): ZendeskFieldIds =>
  getEnvironment() === 'production'
    ? getProductionZendeskContextFieldIds()
    : getSandboxZendeskContextFieldIds()
